import React from 'react';
import { FaDownload, FaFilePdf, FaFileExcel } from 'react-icons/fa6';
import { jsPDF } from 'jspdf';

const ReportGenerator = ({ simulationData, historicalData, model }) => {
  const generatePDF = () => {
    const doc = new jsPDF();
    
    // Add title
    doc.setFontSize(20);
    doc.text('Slip Power Recovery Simulation Report', 20, 20);
    
    // Add simulation parameters
    doc.setFontSize(14);
    doc.text('Simulation Parameters', 20, 40);
    doc.setFontSize(12);
    doc.text(`Drive Type: ${model.driveType === 'scherbius' ? 'Scherbius' : 'Kramer'}`, 25, 50);
    doc.text(`Control Mode: ${model.controlMode === 'open' ? 'Open Loop' : 'Closed Loop'}`, 25, 60);
    doc.text(`Slip: ${(simulationData.slip * 100).toFixed(2)}%`, 25, 70);
    doc.text(`Load Torque: ${model.loadTorque.toFixed(2)} Nm`, 25, 80);
    
    // Add performance metrics
    doc.setFontSize(14);
    doc.text('Performance Metrics', 20, 100);
    doc.setFontSize(12);
    doc.text(`Efficiency: ${(simulationData.efficiency * 100).toFixed(2)}%`, 25, 110);
    doc.text(`Rotor Power: ${(simulationData.rotorPower / 1000).toFixed(2)} kW`, 25, 120);
    doc.text(`Recovered Power: ${(simulationData.recoveredPower / 1000).toFixed(2)} kW`, 25, 130);
    
    // Add charts (would require canvas conversion)
    // ...
    
    // Save the PDF
    doc.save('slip-power-recovery-report.pdf');
  };
  
  const exportCSV = () => {
    // Create CSV content from historical data
    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent += 'Timestamp,Slip (%),Efficiency (%),Rotor Power (kW),Recovered Power (kW)\n';
    
    for (let i = 0; i < historicalData.timestamps.length; i++) {
      const row = [
        new Date(historicalData.timestamps[i]).toISOString(),
        historicalData.slip[i].toFixed(2),
        historicalData.efficiency[i].toFixed(2),
        historicalData.rotorPower[i].toFixed(2),
        historicalData.recoveredPower[i].toFixed(2)
      ];
      csvContent += row.join(',') + '\n';
    }
    
    // Create download link
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'slip-power-recovery-data.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  return (
    <div className="report-generator">
      <button onClick={generatePDF} className="report-btn">
        <FaFilePdf /> Export PDF Report
      </button>
      <button onClick={exportCSV} className="report-btn">
        <FaFileExcel /> Export CSV Data
      </button>
    </div>
  );
};

export default ReportGenerator;